import Section  from "./Section"

let realMadrid = {
    nome: "Real Madrid",
    titulo: "7 Títulos",
    imgUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/5/56/Real_Madrid_CF.svg/1200px-Real_Madrid_CF.svg.png",

}
let milan = {
    nome: "Milan",
    titulo: "4 Títulos",
    imgUrl: "https://logodownload.org/wp-content/uploads/2016/09/milan-logo-1.png",

}
let saoPaulo = {
    nome: "São Paulo",
    titulo: "3 Títulos",
    imgUrl: "https://seeklogo.com/images/S/S__o_Paulo_FC-logo-A33400F9E5-seeklogo.com.png",

}
let bocaJr = {
    nome: "Boca Juniors",
    titulo: "3 Títulos",
    imgUrl: "https://logodownload.org/wp-content/uploads/2016/10/boca-juniors-logo-escudo-1-1.png",

}
let nacional = {
    nome: "Club Nacional-URU",
    titulo: "3 Títulos",
    imgUrl: "https://logodownload.org/wp-content/uploads/2019/04/nacional-do-uruguai-logo-escudo.png",

}
let penarol = {
    nome: "Peñarol",
    titulo: "3 Títulos",
    imgUrl: "https://logodownload.org/wp-content/uploads/2018/04/penarol-logo-escudo-12.png",

}
let bayern = {
    nome: "Bayern Munich",
    titulo: "3 Títulos",
    imgUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/FC_Bayern_M%C3%BCnchen_logo_%282017%29.svg/1200px-FC_Bayern_M%C3%BCnchen_logo_%282017%29.svg.png",

}
let inter = {
    nome: "Internazionale",
    titulo: "3 Títulos",
    imgUrl: "https://logodownload.org/wp-content/uploads/2017/02/inter-milan-logo-1.png",

}
let barcelona = {
    nome: "Barcelona",
    titulo: "3 Títulos",
    imgUrl: "https://logodownload.org/wp-content/uploads/2015/05/Barcelona-logo-escudo.png",

}
let santos = {
    nome: "Santos",
    titulo: "2 Títulos",
    imgUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Santos_logo.svg/640px-Santos_logo.svg.png",

}
let corinthians = {
    nome: "Corinthians",
    titulo: "2 Títulos",
    imgUrl: "https://i0.wp.com/dreamleaguesoccer.com.br/wp-content/uploads/logo-CORINTHIANS.png?fit=512%2C512&ssl=1",

}


export default function SectionPai(){
    return(
        <div>
            <Section  title={realMadrid.nome} titulos={realMadrid.titulo} url={realMadrid.imgUrl}/>
            <Section  title={milan.nome} titulos={milan.titulo} url={milan.imgUrl}/>
            <Section  title={bocaJr.nome} titulos={bocaJr.titulo} url={bocaJr.imgUrl}/>
            <Section  title={saoPaulo.nome} titulos={saoPaulo.titulo} url={saoPaulo.imgUrl}/>
            <Section  title={nacional.nome} titulos={nacional.titulo} url={nacional.imgUrl}/>
            <Section  title={penarol.nome} titulos={penarol.titulo} url={penarol.imgUrl}/>
            <Section  title={bayern.nome} titulos={bayern.titulo} url={bayern.imgUrl}/>
            <Section  title={inter.nome} titulos={inter.titulo} url={inter.imgUrl}/>
            <Section  title={barcelona.nome} titulos={barcelona.titulo} url={barcelona.imgUrl}/>
            <Section  title={santos.nome} titulos={santos.titulo} url={santos.imgUrl}/>
            <Section  title={corinthians.nome} titulos={corinthians.titulo} url={corinthians.imgUrl}/>
            
        </div>
    )
}